import React from 'react';
import UserManagement from '../components/admin/UserManagement';
import AdminLayout from '../components/admin/AdminLayout';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import { useEffect } from 'react';

const AdminUsers = () => {

    const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/login');
      return;
    }

    try {
      const decoded = jwtDecode(token);
      if (decoded?.usertype !== 'master') {
        navigate('/login');
      }
    } catch (err) {
      console.error('Invalid token', err);
      navigate('/login');
    }
  }, [navigate]);

    return (
        <AdminLayout>
            <h1 className="text-3xl font-bold mb-6">Manage Users</h1>
            <UserManagement />
        </AdminLayout>
      );
};

export default AdminUsers;
